import React from "react";

/** Tiny broker glyph — coloured rounded square with the broker's initial(s).
 * Uses a curated palette so MT4/MT5/Exness/Zerodha/Binance/etc. always
 * render with a distinct on-brand mark, no image assets needed. */
const BROKER_META = {
  mt4:        { label: "MT4",       initials: "MT", color: "#0075C4" },
  mt5:        { label: "MT5",       initials: "M5", color: "#F58231" },
  metatrader4:{ label: "MT4",       initials: "MT", color: "#0075C4" },
  metatrader5:{ label: "MT5",       initials: "M5", color: "#F58231" },
  binance:    { label: "Binance",   initials: "BN", color: "#F0B90B" },
  bybit:      { label: "Bybit",     initials: "BY", color: "#F7A600" },
  zerodha:    { label: "Zerodha",   initials: "ZR", color: "#387ED1" },
  exness:     { label: "Exness",    initials: "EX", color: "#F7DC33" },
  xm:         { label: "XM",        initials: "XM", color: "#DC2626" },
  fyers:      { label: "Fyers",     initials: "FY", color: "#001E82" },
  angel:      { label: "Angel One", initials: "AO", color: "#FF6B00" },
  angelone:   { label: "Angel One", initials: "AO", color: "#FF6B00" },
  upstox:     { label: "Upstox",    initials: "UP", color: "#7C3AED" },
  icicidirect:{ label: "ICICI",     initials: "IC", color: "#8B0000" },
  kotak:      { label: "Kotak",     initials: "KT", color: "#0F4C81" },
  dhan:       { label: "Dhan",      initials: "DH", color: "#5546FF" },
  groww:      { label: "Groww",     initials: "GW", color: "#00D09C" },
  ftmo:       { label: "FTMO",      initials: "FT", color: "#00A651" },
  fundednext: { label: "FundedNext",initials: "FN", color: "#6366F1" },
  myforexfunds:{ label: "MFF",      initials: "MF", color: "#22D3EE" },
  the5ers:    { label: "The5%ers",  initials: "5%", color: "#F59E0B" },
  topstep:    { label: "Topstep",   initials: "TS", color: "#EF4444" },
  mftc:       { label: "Tradelog",  initials: "TL", color: "#3B82F6" },
  generic:    { label: "Broker",    initials: "TR", color: "#64748B" },
};

export function BrokerChip({ broker, size = "sm" }) {
  const m = BROKER_META[(broker || "").toLowerCase()] || BROKER_META.generic;
  const dim = size === "lg" ? { chip: "h-9 px-3 gap-2 text-xs", mark: "w-6 h-6 text-[10px]" }
                            : { chip: "h-7 px-2.5 gap-1.5 text-[11px]", mark: "w-5 h-5 text-[9px]" };
  return (
    <span
      data-testid={`broker-chip-${(broker || "").toLowerCase() || "generic"}`}
      className={`inline-flex items-center rounded-full border border-white/10 bg-white/[0.04] backdrop-blur ${dim.chip}`}
      title={m.label}>
      <span
        className={`grid place-items-center rounded-md font-bold text-white shadow-lg leading-none ${dim.mark}`}
        style={{
          background: `linear-gradient(135deg, ${m.color}, ${m.color}CC)`,
          boxShadow: `0 4px 12px ${m.color}55, inset 0 1px 0 rgba(255,255,255,0.3)`,
        }}>
        {m.initials}
      </span>
      <span className="font-semibold text-neutral-200 tracking-wide leading-none">{m.label}</span>
    </span>
  );
}

export function SymbolChip({ symbol }) {
  return (
    <span className="inline-flex items-center h-6 px-2 rounded-full bg-white/[0.06] border border-white/10 text-[10px] font-mono text-neutral-300 tracking-wider leading-none">
      {symbol}
    </span>
  );
}

export default BrokerChip;
